var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8688 5.69063L27.3688 0.690625C27.2648 0.482951 27.1051 0.308332 26.9075 0.186346C26.7099 0.0643614 26.4822 -0.000165938 26.25 3.20471e-07H3.75C3.51778 -0.000165938 3.2901 0.0643614 3.09249 0.186346C2.89489 0.308332 2.73517 0.482951 2.63125 0.690625L0.13125 5.69063C0.0450888 5.86452 0.000175758 6.05593 0 6.25V27.5C0 28.163 0.263392 28.7989 0.732233 29.2678C1.20107 29.7366 1.83696 30 2.5 30H27.5C28.163 30 28.7989 29.7366 29.2678 29.2678C29.7366 28.7989 30 28.163 30 27.5V6.25C29.9998 6.05593 29.9549 5.86452 29.8688 5.69063ZM4.52187 2.5H25.4781L26.7281 5H3.27187L4.52187 2.5ZM27.5 27.5H2.5V7.5H27.5V27.5Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.be76c9ed5c53a97fe261c5e1df7edb33.svg";
export { ForwardRef as ReactComponent };